import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { Close } from '../../Icons/Close';
// import { DragHand } from '../Icons/DragHand';
import InstructionsImage from '../../assets/images/map/anim_instruction.png';
import { InstructionsProps } from '../../interfaces/components';
import { useTranslation } from 'react-i18next';

const MapInstructions = ({ active, setActive }: InstructionsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding={['15px', '15px', '15px', '15px']}
        width={['95vw', '350px', '380px', '420px', '420px']}
        height={['440px', '470px', '480px', '500px', '500px']}
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['25px', '25px', '25px']}
          right={['25px', '25px', '25px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Box>
          <Text
            textAlign="center"
            fontWeight="400"
            fontSize={['16px', '16px', '18px', '22px', '22px']}
            width="100%"
            mt="10"
            className="copy"
            fontFamily="SangBleuBPLight"
            mb="5"
          >
            {t('map-instructions-text-one')}
          </Text>

          <Image src={InstructionsImage} w={['250px', '280px', '280px']} h="auto" m="0px auto" objectFit="contain" />
          <Text
            textAlign="center"
            fontWeight="400"
            fontSize={['16px', '16px', '18px', '22px', '22px']}
            width="100%"
            mt="5"
            className="copy"
            fontFamily="SangBleuBPLight"
          >
            {t('map-instructions-text-two')}
          </Text>
        </Box>
      </Box>
    </>
  );
};
export default MapInstructions;
